import { omit } from 'lodash';
import { call, put, takeEvery } from 'redux-saga/effects';

import { REDUX_STORE } from '@funnels/constants';
import {
  DeleteBrokerInterviewsAction,
  FetchBrokerInterviewsAction,
  ServerBrokerInterviewFetch,
  ServerBrokerInterviewUpsert,
  UpsertBrokerInterviewsAction,
} from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { waitForAuth } from '../_common';
import {
  deleteBrokerInterviewsFail,
  deleteBrokerInterviewsSuccess,
  fetchBrokerInterviewsFail,
  fetchBrokerInterviewsSuccess,
  upsertBrokerInterviewsFail,
  upsertBrokerInterviewsSuccess,
} from './actions';
import BrokerInterviewsAPI from './api';

export function* deleteBrokerInterviewsWorker(action: DeleteBrokerInterviewsAction) {
  try {
    yield waitForAuth();
    const { applicationId } = action;

    yield call(BrokerInterviewsAPI.del, applicationId);

    yield put(deleteBrokerInterviewsSuccess());
  } catch (e: any) {
    datadogUtil.addError(e);
    const { clientId } = action;
    yield put(deleteBrokerInterviewsFail(clientId, e.response?.data || e.message));
  }
}

export function* fetchBrokerInterviewsWorker(action: FetchBrokerInterviewsAction): any {
  try {
    yield waitForAuth();

    const { applicationId } = action;
    const response = yield call(BrokerInterviewsAPI.fetch, applicationId);
    const brokerInterviews = [response.data].filter((v) => v.applicationId).map((v) => omit(v, ['meta', 'updatedAt']));
    yield put(fetchBrokerInterviewsSuccess(brokerInterviews as ServerBrokerInterviewFetch[]));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield put(fetchBrokerInterviewsFail(e.response?.data || e.message));
  }
}

export function* upsertBrokerInterviewsWorker(action: UpsertBrokerInterviewsAction): any {
  try {
    yield waitForAuth();
    const brokerInterview = action.brokerInterviews[0];

    const brokerInterviewPayload = omit(brokerInterview, [
      'id',
      'clientId',
      'createdAt',
      'isDeleted',
      'isDeidentified',
      'applicationId',
      'applicantId',
    ]) as ServerBrokerInterviewUpsert;

    const response = yield call(BrokerInterviewsAPI.upsert, action.applicationId, brokerInterviewPayload);
    yield put(upsertBrokerInterviewsSuccess({ ...brokerInterview, id: response.data.id }));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield put(upsertBrokerInterviewsFail(e.response?.data || e.message));
  }
}

export function* brokerInterviewsWatcher() {
  yield takeEvery(REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.DELETE_BROKER_INTERVIEWS, deleteBrokerInterviewsWorker);
  yield takeEvery(REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.FETCH_BROKER_INTERVIEWS, fetchBrokerInterviewsWorker);
  yield takeEvery(REDUX_STORE.BROKER_INTERVIEWS.ACTION_TYPES.UPSERT_BROKER_INTERVIEWS, upsertBrokerInterviewsWorker);
}

export default brokerInterviewsWatcher;
